<template>
    <div class="personal-body">
        <div class="personal-top">
            <backindex :msg="topMsg"></backindex>
        </div>
        <!--顶部u头像信息-->
        <div class="user-area">
            <div class="user-photo">
                <img :src="avatar" v-if="$J.trim(avatar)!=''">
                <img src="../assets/imgs/photo.png" v-if="$J.trim(avatar)==''">
            </div>
            <div class="user-msg" v-if="uid==0">
                <span @click="go.goLogin">{{$t("login")}}</span>
                <span>/</span>
                <span @click="go.goReg">{{$t("reg")}}</span>
            </div>
            <div class="user-msg" v-else>
                <span>{{email}}</span>
                <span>|</span>
                <span>{{level}}</span>
            </div>
        </div>
        <!--个人中心功能区-->
        <div class="personal-area">
            <div class="my-coin">
                <div class="item-left">
                    <div class="left-img">
                        <img src="../assets/imgs/my-coin.png" class="coin-img" alt="">
                    </div>
                    <div class="left-font">{{$t("myCoin")}}</div>
                </div>
                <div class="item-right">
                    <div class="coin-num">{{coin}}{{$t("coin")}}</div>
                    <div class="add-coin" @click="go.goPay()">{{$t("charge2")}}</div>
                    <div class="right-img">
                        <img src="../assets/imgs/next.png" alt="">
                    </div>
                </div>
            </div>
            <div class="my-item" @click="go.goMybook">
                <div class="item-left">
                    <div class="left-img">
                        <img src="../assets/imgs/my-book.png" class="book-img" alt="">
                    </div>
                    <div class="left-font" >{{$t("bookMsg")}}</div>
                </div>
                <div class="item-right">
                    <div class="right-img">
                        <img src="../assets/imgs/next.png" alt="">
                    </div>
                </div>
            </div>
            <div class="my-item"  @click="openSetlang">
                <div class="item-left">
                    <div class="left-img">
                        <img src="../assets/imgs/lang-set.png" class="lang-img" alt="">
                    </div>
                    <div class="left-font">{{$t("langSetting")}}</div>
                </div>
                <div class="item-right">
                    <div class="right-lang">{{langLabel}}</div>
                    <div class="right-img">
                        <img src="../assets/imgs/next.png" alt="">
                    </div>
                </div>
            </div>
            <div class="my-item" @click="changepwd">
                <div class="item-left">
                    <div class="left-img">
                        <img src="../assets/imgs/change-pass.png" class="pass-img" alt="">
                    </div>
                    <div class="left-font">{{$t("changePwd")}}</div>
                </div>
                <div class="item-right">
                    <div class="right-img">
                        <img src="../assets/imgs/next.png" alt="">
                    </div>
                </div>
            </div>
            <div class="my-item" @click="go.feedback">
                <div class="item-left" >
                    <div class="left-img">
                        <img src="../assets/imgs/program.png" class="program-img" alt="">
                    </div>
                    <div class="left-font">{{$t("feedback")}}</div>
                </div>
                <div class="item-right">
                    <div class="right-img">
                        <img src="../assets/imgs/next.png" alt="">
                    </div>
                </div>
            </div>
            <div class="my-item" @click="go.downloadApp">
                <div class="item-left">
                    <div class="left-img">
                        <img src="../assets/imgs/load-qqk.png" class="load-img" alt="">
                    </div>
                    <div class="left-font" >{{$t("download")}}</div>
                </div>
                <div class="item-right">
                    <div class="right-img">
                        <img src="../assets/imgs/next.png" alt="">
                    </div>
                </div>
            </div>

            <div class="logout-btn" v-if="uid>0">
                <div class="logout-click" @click="logout">{{$t("logout")}}</div>
            </div>
        </div>
        <!--底部-->
        <pagebottom  :flag="showLang"  :setl="this.setLang"></pagebottom>
    </div>
</template>

<script>
    import backindex from "@/components/common/backindex"
    import pagebottom from "@/components/common/pagebottom"
    export default {
        name: "personal",
        components:{
            backindex,
            pagebottom
        },
        data(){
            return{
                topMsg:"个人中心",
                avatar:"",
                email:"",
                level:"",
                coin:0,
                uid:0,
                //  语言开关
                showLang:false,
                langFlag:"zh",
            }
        },
        computed:{
            langLabel:function(){
                this.langFlag = localStorage.getItem("lang")?localStorage.getItem("lang"):this.$i18n.locale;
                return this.langFlag=="zh"?"简体中文":(this.langFlag=="zh-tw"?"繁体中文":"English");
            }
        },
        mounted:function(){
            this.topMsg = this.$t("my");
            this.getUser();
            //获取字体设置
            this.langFlag = localStorage.getItem("lang")?localStorage.getItem("lang"):this.$i18n.locale;
        },
        methods:{
            changepwd:function(){
                if(this.go.checkLogin()){
                    this.go.changepwd();
                }else{
                    this.go.goLogin();
                }
            }, 
            logout:function(){
                localStorage.removeItem("loginUserID");
                this.req.logout().then(res=>{
                    document.location.reload();
                })
            },
            getUser:function(){
                this.req.getUser().then(res=>{
                    if(res.data.id>0){
                        this.uid = res.data.id;
                        this.coin = res.data.score
                        this.avatar = res.data.img;
                        this.email = this.$J.trim(res.data.email)!=""?res.data.email:(this.$J.trim(res.data.username)!=""?res.data.username:(this.$J.trim(res.data.tele)!=""?res.data.tele:""));
                        this.level = res.data.level;
                        this.langFlag = (res.data.lang=="zh-cn"||res.data.lang=="zh")?"zh":"zh-tw";
                    }else{
                        this.uid=0;
                        this.coin=0;
                        this.avatar="";
                        this.email="";
                        this.level = "";
                    }
                })
            },
            //设置语言
            openSetlang:function(){
                this.showLang = true;
            },
            setLang:function(lang){
                if(lang == this.langFlag) {
                    return;
                }
                this.langFlag = lang;
                this.showLang = false;
            },
        }
    }
</script>

<style scoped>
    .personal-top{
        width: 100%;
        height: auto;
        position: fixed;
        left: 0;
        top: 0;
    }
    .user-area{
        width: 100%;
        height: 3rem;
        background: url("../assets/imgs/user-back.png") no-repeat center/cover;
        box-sizing: border-box;
        padding-top: 0.68rem;
        margin-top: 1.12rem;
    }
    .user-photo{
        width: 1.06rem;
        height: 1.06rem;
        margin:  0 auto;
    }
    .user-photo img{
        width: 1.06rem;
        height: 1.06rem;
        border-radius:50%;-webkit-border-radius:50%;-moz-border-radius:50%;
    }
    .user-msg{
        text-align: center;
        font-size: 0.28rem;
        color:#000;
        font-weight: 700;
        padding: 0.32rem 0 0 0;
    }
    .personal-area{
        width: 100%;
        padding-top: 0.1rem;
    }
    .my-coin,.my-item{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 0 0.4rem;
        border-bottom: 0.01rem solid #f2f2f2;
    }
    .my-coin{
        height: 1.29rem;
    }
    .my-item{
        height: 1.19rem;
    }
    .item-left,.item-right{
        display: flex;
        align-items: center;
    }
    .left-img{
        width: 0.4rem;
    }
    .left-img img{
        display: block;
        margin: 0 auto;
    }
    .left-font{
        font-size: 0.26rem;
        line-height: 0.26rem;
        padding-left: 0.2rem;
    }
    .coin-num{
        font-size: 0.26rem;
        line-height: 0.26rem;
        font-weight: 700;
        padding-right: 0.2rem;
    }
    .add-coin{
        width: 1rem;
        height: 0.48rem;
        background: #ff1f4f;
        border-radius: 0.06rem;
        font-size: 0.26rem;
        line-height: 0.48rem;
        text-align: center;
        color: #fff;
    }
    .coin-img,.lang-img,.program-img,.load-img{
        width: 0.4rem;
        height: 0.4rem;
    }
    .book-img,.pass-img{
        width: 0.32rem;
        height: 0.4rem;
    }
    .right-img{
        padding-left: 0.2rem;
    }
    .right-img img{
        display: block;
        width: 0.2rem;
        height: 0.32rem;
    }
    .right-lang{
        font-size: 0.26rem;
        padding-right: 0.16rem;
        color: #ff1f4f;
    }
    /*设置语言*/
    .set-body{
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.7);
        position: fixed;
        left: 0;
        top:0;
    }
    .set-area{
        width: 4.74rem;
        height: 5.68rem;
        background: #ffffff;
        border-radius: 0.1rem;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        animation: scale 0.6s;
    }
    .set-title{
        width: 100%;
        height: 1.14rem;
        border-bottom: 0.02rem solid #e6e6e6;
        font-size: 0.34rem;
        color: #ff1f4f;
        text-align: center;
        line-height: 1.14rem;
        font-weight: 700;
    }
    .set-select{
        width: 100%;
        height: 4.5rem;
        box-sizing: border-box;
        padding: 1rem 0.86rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    .lang-item{
        width: 100%;
        height: 0.76rem;
        background: #999999;
        color: #ffffff;
        font-size: 0.34rem;
        line-height: 0.76rem;
        font-weight: 700;
        border-radius: 0.08rem;
        text-align: center;
    }
    .lang-select{
        background: #ff1f4f;
    }
    @keyframes scale {
       0%{
           transform: scale(1.2,1.2);
       }
        60%{
            transform: scale(0.9,0.9);
        }
        100%{
            transform: scale(1,1);
        }
    }
    .logout-btn{
        width: 90%;
        margin: 1em auto;
        box-sizing: border-box;
        padding: 0 0.2rem;
    }
    .logout-click{
        width: 100%;
        height: 0.84rem;
        font-size: 0.32rem;
        color: #FFFFFF;
        line-height: 0.84rem;
        background: #ff1f4f;
        border-radius: 0.08rem;
        text-align: center;
        font-weight: 700;
    }
</style>


// WEBPACK FOOTER //
// src/components/personal.vue